import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';

export const typPozadavkuSelect = [
    {
        value: '',
        labelcz: 'VYBERTE'
    },
    {
        value: ETypPozadavku.UPIS,
        labelcz: 'SS_NOVY_POZADAVEK_NA_UPIS'
    },
    {
        value: ETypPozadavku.PREVOD,
        labelcz: 'SS_NOVY_POZADAVEK_NA_PREVOD'
    },
    {
        value: ETypPozadavku.PREVODZPET,
        labelcz: 'SS_NOVY_POZADAVEK_NA_PREVODZPET'
    },
    {
        value: ETypPozadavku.NAVYSENI,
        labelcz: 'SS_NOVY_POZADAVEK_NA_NAVYSENI'
    },
    {
        value: ETypPozadavku.SICAV,
        labelcz: 'SS_NOVY_POZADAVEK_NA_SICAV'
    }
];
